/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SprintsRouteRouteImport } from './routes/sprints/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as TodayIndexRouteImport } from './routes/today/index'
import { Route as SprintsIndexRouteImport } from './routes/sprints/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as PermitsIndexRouteImport } from './routes/permits/index'
import { Route as MonitoringIndexRouteImport } from './routes/monitoring/index'
import { Route as IntakeIndexRouteImport } from './routes/intake/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as ContractorsIndexRouteImport } from './routes/contractors/index'
import { Route as BoardIndexRouteImport } from './routes/board/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as SprintsCyclesRouteImport } from './routes/sprints/cycles'
import { Route as SprintsCurrentRouteImport } from './routes/sprints/current'
import { Route as PermitsPermitIdRouteImport } from './routes/permits/$permitId'
import { Route as DashboardPreviewRouteImport } from './routes/dashboard/preview'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AdminStaffRouteImport } from './routes/admin/staff'
import { Route as AdminOnboardRouteImport } from './routes/admin/onboard'
import { Route as AdminOrgIdRouteImport } from './routes/admin/$orgId'

const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SprintsRouteRoute = SprintsRouteRouteImport.update({
  id: '/sprints',
  path: '/sprints',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const TodayIndexRoute = TodayIndexRouteImport.update({
  id: '/today/',
  path: '/today/',
  getParentRoute: () => rootRouteImport,
} as any)
const SprintsIndexRoute = SprintsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SprintsRouteRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const PermitsIndexRoute = PermitsIndexRouteImport.update({
  id: '/permits/',
  path: '/permits/',
  getParentRoute: () => rootRouteImport,
} as any)
const MonitoringIndexRoute = MonitoringIndexRouteImport.update({
  id: '/monitoring/',
  path: '/monitoring/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntakeIndexRoute = IntakeIndexRouteImport.update({
  id: '/intake/',
  path: '/intake/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorsIndexRoute = ContractorsIndexRouteImport.update({
  id: '/contractors/',
  path: '/contractors/',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardIndexRoute = BoardIndexRouteImport.update({
  id: '/board/',
  path: '/board/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const SprintsCyclesRoute = SprintsCyclesRouteImport.update({
  id: '/cycles',
  path: '/cycles',
  getParentRoute: () => SprintsRouteRoute,
} as any)
const SprintsCurrentRoute = SprintsCurrentRouteImport.update({
  id: '/current',
  path: '/current',
  getParentRoute: () => SprintsRouteRoute,
} as any)
const PermitsPermitIdRoute = PermitsPermitIdRouteImport.update({
  id: '/permits/$permitId',
  path: '/permits/$permitId',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPreviewRoute = DashboardPreviewRouteImport.update({
  id: '/dashboard/preview',
  path: '/dashboard/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminStaffRoute = AdminStaffRouteImport.update({
  id: '/admin/staff',
  path: '/admin/staff',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOnboardRoute = AdminOnboardRouteImport.update({
  id: '/admin/onboard',
  path: '/admin/onboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrgIdRoute = AdminOrgIdRouteImport.update({
  id: '/admin/$orgId',
  path: '/admin/$orgId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sprints': typeof SprintsRouteRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/admin/$orgId': typeof AdminOrgIdRoute
  '/admin/onboard': typeof AdminOnboardRoute
  '/admin/staff': typeof AdminStaffRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/dashboard/preview': typeof DashboardPreviewRoute
  '/permits/$permitId': typeof PermitsPermitIdRoute
  '/sprints/current': typeof SprintsCurrentRoute
  '/sprints/cycles': typeof SprintsCyclesRoute
  '/admin/': typeof AdminIndexRoute
  '/board/': typeof BoardIndexRoute
  '/contractors/': typeof ContractorsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/intake/': typeof IntakeIndexRoute
  '/monitoring/': typeof MonitoringIndexRoute
  '/permits/': typeof PermitsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/sprints/': typeof SprintsIndexRoute
  '/today/': typeof TodayIndexRoute
  '/users/': typeof UsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/admin/$orgId': typeof AdminOrgIdRoute
  '/admin/onboard': typeof AdminOnboardRoute
  '/admin/staff': typeof AdminStaffRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/dashboard/preview': typeof DashboardPreviewRoute
  '/permits/$permitId': typeof PermitsPermitIdRoute
  '/sprints/current': typeof SprintsCurrentRoute
  '/sprints/cycles': typeof SprintsCyclesRoute
  '/admin': typeof AdminIndexRoute
  '/board': typeof BoardIndexRoute
  '/contractors': typeof ContractorsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/intake': typeof IntakeIndexRoute
  '/monitoring': typeof MonitoringIndexRoute
  '/permits': typeof PermitsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/sprints': typeof SprintsIndexRoute
  '/today': typeof TodayIndexRoute
  '/users': typeof UsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/sprints': typeof SprintsRouteRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/admin/$orgId': typeof AdminOrgIdRoute
  '/admin/onboard': typeof AdminOnboardRoute
  '/admin/staff': typeof AdminStaffRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/dashboard/preview': typeof DashboardPreviewRoute
  '/permits/$permitId': typeof PermitsPermitIdRoute
  '/sprints/current': typeof SprintsCurrentRoute
  '/sprints/cycles': typeof SprintsCyclesRoute
  '/admin/': typeof AdminIndexRoute
  '/board/': typeof BoardIndexRoute
  '/contractors/': typeof ContractorsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/intake/': typeof IntakeIndexRoute
  '/monitoring/': typeof MonitoringIndexRoute
  '/permits/': typeof PermitsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/sprints/': typeof SprintsIndexRoute
  '/today/': typeof TodayIndexRoute
  '/users/': typeof UsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sprints'
    | '/sign-in'
    | '/sign-up'
    | '/admin/$orgId'
    | '/admin/onboard'
    | '/admin/staff'
    | '/auth/callback'
    | '/dashboard/preview'
    | '/permits/$permitId'
    | '/sprints/current'
    | '/sprints/cycles'
    | '/admin/'
    | '/board/'
    | '/contractors/'
    | '/dashboard/'
    | '/intake/'
    | '/monitoring/'
    | '/permits/'
    | '/settings/'
    | '/sprints/'
    | '/today/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/admin/$orgId'
    | '/admin/onboard'
    | '/admin/staff'
    | '/auth/callback'
    | '/dashboard/preview'
    | '/permits/$permitId'
    | '/sprints/current'
    | '/sprints/cycles'
    | '/admin'
    | '/board'
    | '/contractors'
    | '/dashboard'
    | '/intake'
    | '/monitoring'
    | '/permits'
    | '/settings'
    | '/sprints'
    | '/today'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/sprints'
    | '/sign-in'
    | '/sign-up'
    | '/admin/$orgId'
    | '/admin/onboard'
    | '/admin/staff'
    | '/auth/callback'
    | '/dashboard/preview'
    | '/permits/$permitId'
    | '/sprints/current'
    | '/sprints/cycles'
    | '/admin/'
    | '/board/'
    | '/contractors/'
    | '/dashboard/'
    | '/intake/'
    | '/monitoring/'
    | '/permits/'
    | '/settings/'
    | '/sprints/'
    | '/today/'
    | '/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SprintsRouteRoute: typeof SprintsRouteRouteWithChildren
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  AdminOrgIdRoute: typeof AdminOrgIdRoute
  AdminOnboardRoute: typeof AdminOnboardRoute
  AdminStaffRoute: typeof AdminStaffRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  DashboardPreviewRoute: typeof DashboardPreviewRoute
  PermitsPermitIdRoute: typeof PermitsPermitIdRoute
  AdminIndexRoute: typeof AdminIndexRoute
  BoardIndexRoute: typeof BoardIndexRoute
  ContractorsIndexRoute: typeof ContractorsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  IntakeIndexRoute: typeof IntakeIndexRoute
  MonitoringIndexRoute: typeof MonitoringIndexRoute
  PermitsIndexRoute: typeof PermitsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TodayIndexRoute: typeof TodayIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sprints': {
      id: '/sprints'
      path: '/sprints'
      fullPath: '/sprints'
      preLoaderRoute: typeof SprintsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/today/': {
      id: '/today/'
      path: '/today'
      fullPath: '/today/'
      preLoaderRoute: typeof TodayIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sprints/': {
      id: '/sprints/'
      path: '/'
      fullPath: '/sprints/'
      preLoaderRoute: typeof SprintsIndexRouteImport
      parentRoute: typeof SprintsRouteRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/permits/': {
      id: '/permits/'
      path: '/permits'
      fullPath: '/permits/'
      preLoaderRoute: typeof PermitsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/monitoring/': {
      id: '/monitoring/'
      path: '/monitoring'
      fullPath: '/monitoring/'
      preLoaderRoute: typeof MonitoringIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intake/': {
      id: '/intake/'
      path: '/intake'
      fullPath: '/intake/'
      preLoaderRoute: typeof IntakeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contractors/': {
      id: '/contractors/'
      path: '/contractors'
      fullPath: '/contractors/'
      preLoaderRoute: typeof ContractorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/board/': {
      id: '/board/'
      path: '/board'
      fullPath: '/board/'
      preLoaderRoute: typeof BoardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sprints/cycles': {
      id: '/sprints/cycles'
      path: '/cycles'
      fullPath: '/sprints/cycles'
      preLoaderRoute: typeof SprintsCyclesRouteImport
      parentRoute: typeof SprintsRouteRoute
    }
    '/sprints/current': {
      id: '/sprints/current'
      path: '/current'
      fullPath: '/sprints/current'
      preLoaderRoute: typeof SprintsCurrentRouteImport
      parentRoute: typeof SprintsRouteRoute
    }
    '/permits/$permitId': {
      id: '/permits/$permitId'
      path: '/permits/$permitId'
      fullPath: '/permits/$permitId'
      preLoaderRoute: typeof PermitsPermitIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/preview': {
      id: '/dashboard/preview'
      path: '/dashboard/preview'
      fullPath: '/dashboard/preview'
      preLoaderRoute: typeof DashboardPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/staff': {
      id: '/admin/staff'
      path: '/admin/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AdminStaffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/onboard': {
      id: '/admin/onboard'
      path: '/admin/onboard'
      fullPath: '/admin/onboard'
      preLoaderRoute: typeof AdminOnboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/$orgId': {
      id: '/admin/$orgId'
      path: '/admin/$orgId'
      fullPath: '/admin/$orgId'
      preLoaderRoute: typeof AdminOrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SprintsRouteRouteChildren {
  SprintsCurrentRoute: typeof SprintsCurrentRoute
  SprintsCyclesRoute: typeof SprintsCyclesRoute
  SprintsIndexRoute: typeof SprintsIndexRoute
}

const SprintsRouteRouteChildren: SprintsRouteRouteChildren = {
  SprintsCurrentRoute: SprintsCurrentRoute,
  SprintsCyclesRoute: SprintsCyclesRoute,
  SprintsIndexRoute: SprintsIndexRoute,
}

const SprintsRouteRouteWithChildren = SprintsRouteRoute._addFileChildren(
  SprintsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SprintsRouteRoute: SprintsRouteRouteWithChildren,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  AdminOrgIdRoute: AdminOrgIdRoute,
  AdminOnboardRoute: AdminOnboardRoute,
  AdminStaffRoute: AdminStaffRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  DashboardPreviewRoute: DashboardPreviewRoute,
  PermitsPermitIdRoute: PermitsPermitIdRoute,
  AdminIndexRoute: AdminIndexRoute,
  BoardIndexRoute: BoardIndexRoute,
  ContractorsIndexRoute: ContractorsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  IntakeIndexRoute: IntakeIndexRoute,
  MonitoringIndexRoute: MonitoringIndexRoute,
  PermitsIndexRoute: PermitsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TodayIndexRoute: TodayIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
